// Değerler veritabanında saklanan izin türü metinleridir; çeviri anahtarı olarak kod (ANNUAL vb.) kullanılır
export const LeaveTypeEnum = Object.freeze({
  ANNUAL: "Yıllık izin",
  SICK: "Hastalık izni",
  UNPAID: "Ücretsiz izin",
  MATERNITY: "Doğum izni",
});

export const LEAVE_TYPES = Object.freeze(Object.values(LeaveTypeEnum));

const leaveTypeCodeByValue = Object.fromEntries(
  Object.entries(LeaveTypeEnum).map(([code, value]) => [value, code])
);

export const leaveTypeLabel = (t, type, fallback = "") => {
  const code = leaveTypeCodeByValue[type];
  return code ? t(`leavesType.${code}`) : type || fallback;
};
